import axios from "axios";

import { AXIOS_DEFAULT_CONFIG, routes } from "../../constants";

const fetcByEmail = async (email) => {
    const response = await axios.get(routes.fetchUser(email), AXIOS_DEFAULT_CONFIG);
    return response;
};
export default fetcByEmail;
